// extracted by mini-css-extract-plugin
export default {"tagsSection":"TagsSection-module__tagsSection__iWdfz6b","categories":"TagsSection-module__categories__XHRZvl0"};